
import { getNameUser } from '../../../functions/agent/agentModuleComponent/getNameUser'
import { getUnitAddress } from '../../../functions/agent/agentModuleComponent/getUnitAddres'
import { getCurrentDubaiDate } from '../../../functions/agent/date/getCurrentDubaiDate'
import { toUTCWithOffset } from '../../../functions/agent/date/toUTCWithOffset'
import { getErrorss } from '../../../functions/errors/GetErrors'
import { getQueryAdvertises } from '../../../functions/shared/api/queries/getQueryAdvertises'
import { sendNotification } from '../../../functions/shared/notifications/sendNotification'
import { ACCESS_KEY, urlAPI, USER_ID_KEY } from '../../../urls'
import { setAdvertises } from '../../slices/advertisesSlice'
import { dataFetchingFinish, dataFetchingStart, setWhereAfterToGo } from '../../slices/modalSlice'
import { setFilterNavigate } from '../../slices/scheduleSlice'
import { type User } from '../../slices/userSlice'
import { type AppDispatch, type RootState } from '../../store'
import { isPortalLinkEntry, normalizeLinksArray, normalizeLinkStatus } from '../../../functions/agent/advertises/portalLinks'

export const createLinksAdvertiseAction = (formValues: Record<string, any>) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const jwt = window.localStorage.getItem(ACCESS_KEY)
    const userID = window.localStorage.getItem(USER_ID_KEY)
    try {
        dispatch(dataFetchingStart())
        const currentAdvertise = getState().advertises.advertises?.find((adv) => adv.id === Number(formValues?.objectID))
        const currentStatus = currentAdvertise?.attributes?.Statuses?.[currentAdvertise?.attributes?.Statuses?.length - 1]
        const isPortalLinksFlow = currentStatus === 'Links approved' || currentStatus === 'Advertisement started'
        const currentLinks = normalizeLinksArray(currentAdvertise?.attributes?.Links)
        const rawPortalLinks = Array.isArray(formValues?.form?.links) ? formValues.form.links : []

        const sanitizePortalLink = (link: Record<string, any>) => ({
            ...link,
            Portal: typeof link?.Portal === 'string' ? link.Portal.trim() : (typeof link?.Title === 'string' ? link.Title.trim() : ''),
            Title: typeof link?.Title === 'string' ? link.Title.trim() : '',
            Link: typeof link?.Link === 'string' ? link.Link.trim() : '',
            Comment: typeof link?.Comment === 'string' ? link.Comment.trim() : '',
            Feedback: typeof link?.Feedback === 'string' ? link.Feedback.trim() : (typeof link?.Comment === 'string' ? link.Comment.trim() : ''),
            IsDisabled: Boolean(link?.IsDisabled ?? link?.Disabled),
            Disabled: Boolean(link?.Disabled ?? link?.IsDisabled),
            Status: normalizeLinkStatus(link?.Status)
        })

        type NormalizedPortalLink = Record<string, any> & {
            Portal: string
            Title: string
            Link: string
            Comment: string
            Feedback: string
            IsDisabled: boolean
            Disabled: boolean
            Status: string
            __sourceIndex?: number
        }

        const normalizedPortalLinks: NormalizedPortalLink[] = rawPortalLinks.map((row: Record<string, any>) => sanitizePortalLink(row))

        if (!isPortalLinksFlow) {
            const existingPortalLinks = currentLinks.filter((link) => isPortalLinkEntry(link))
            type TrakheesiDraftLink = {
                Trakheesi_id: string
                Status: string
                Title: string
                Link: string
            }
            const normalizedTrakheesiLinks = rawPortalLinks
                .map((row: Record<string, any>): TrakheesiDraftLink => ({
                    Trakheesi_id: typeof row?.Trakheesi_id === 'string' ? row.Trakheesi_id.trim() : '',
                    Status: normalizeLinkStatus(row?.Status),
                    Title: typeof row?.Title === 'string' ? row.Title.trim() : '',
                    Link: typeof row?.Link === 'string' ? row.Link.trim() : ''
                }))
                .filter((row: TrakheesiDraftLink) => row.Trakheesi_id.length > 0)

            const legacyLinks = [...normalizedTrakheesiLinks, ...existingPortalLinks]
            const sendObject = {
                method: 'PUT',
                collection: 'unit-advertises',
                id: Number(formValues?.objectID),
                query: getQueryAdvertises(),
                body: {
                    Links: legacyLinks,
                    Statuses: ['Links added'],
                    Notify: 'BSO'
                }
            }

            const response = await fetch(`${urlAPI}`, {
                method: 'POST',
                body: JSON.stringify(sendObject),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwt}`
                }
            })
            const dataJSON = await response.json()
            if (dataJSON.success) {
                if (dataJSON.response.error != null) {
                    dispatch(dataFetchingFinish())
                    return { ...dataJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
                } else {
                    const currentUnit = getState().units?.units?.filter((el: any) => el.id === Number(formValues.unitID))[0]
                    const currentUser = getState().user.currentUser
                    const nameUser = getNameUser(currentUser as User)
                    const unitAdress = getUnitAddress(currentUnit)
                    const inMomentViewingForAdmin = toUTCWithOffset(getCurrentDubaiDate(), 1)
                    dispatch(dataFetchingFinish())
                    dispatch(setAdvertises(dataJSON.response.data))
                    dispatch(setFilterNavigate('adverts'))
                    dispatch(setWhereAfterToGo('/agent/schedule'))
                    await sendNotification(inMomentViewingForAdmin, Number(currentUser.id ?? userID), dataJSON.response.data.id, 'admin-advertise-links-added', `Attention admin, ${nameUser} created link an advertise for ${unitAdress}.`)
                    return { ...dataJSON, textNavigate: `/agent/modalView/advertise_modal/${dataJSON?.response?.data?.attributes?.Unit?.data?.id}/${dataJSON?.response?.data?.id}/not`, isSuccessful: true, textNotification: 'You have successfully updated the advertising Trakheesi IDs' }
                }
            } else {
                dispatch(dataFetchingFinish())
                return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
            }
        }

        const currentWithIndexes = currentLinks.map((link, index) => ({ ...link, __sourceIndex: index }))
        const updatesBySourceIndex = new Map<number, Record<string, any>>()

        normalizedPortalLinks.forEach((portalRow: NormalizedPortalLink) => {
            if (typeof portalRow?.__sourceIndex === 'number') {
                updatesBySourceIndex.set(portalRow.__sourceIndex, portalRow)
            }
        })

        const mergedLinks = currentWithIndexes.map((link) => {
            if (!isPortalLinkEntry(link)) {
                return link
            }
            const update = updatesBySourceIndex.get(link.__sourceIndex)
            if (update == null) {
                return link
            }
            return {
                ...link,
                Portal: update.Portal,
                Title: update.Title,
                Link: update.Link,
                Comment: update.Comment,
                Feedback: update.Feedback,
                IsDisabled: update.IsDisabled,
                Disabled: update.Disabled,
                Status: update.Status
            }
        })

        const existingTrackedIndexes = new Set(currentWithIndexes.map((link) => link.__sourceIndex))
        const existingPortalKeys = new Set(
            mergedLinks
                .filter((link) => isPortalLinkEntry(link))
                .map((link) => `${String(link?.Title ?? '').trim().toLowerCase()}::${String(link?.Link ?? '').trim().toLowerCase()}`)
        )

        const newPortalLinks = normalizedPortalLinks
            .filter((portalRow: NormalizedPortalLink) => typeof portalRow?.__sourceIndex !== 'number' || !existingTrackedIndexes.has(portalRow.__sourceIndex))
            .filter((portalRow: NormalizedPortalLink) => portalRow.Title.length > 0 || portalRow.Link.length > 0)
            .filter((portalRow: NormalizedPortalLink) => {
                const key = `${portalRow.Title.toLowerCase()}::${portalRow.Link.toLowerCase()}`
                if (existingPortalKeys.has(key)) {
                    return false
                }
                existingPortalKeys.add(key)
                return true
            })

        const Links = [...mergedLinks, ...newPortalLinks].map(({ __sourceIndex, ...link }) => link)
        const sendObject = {
            method: 'PUT',
            collection: 'unit-advertises',
            id: Number(formValues?.objectID),
            query: getQueryAdvertises(), 
            body: {
                Links,
                Statuses: ['Links added'],
                Notify: 'BSO'
            }
        }

        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        const dataJSON = await response.json()
        if (dataJSON.success) {
            if (dataJSON.response.error != null) {
                dispatch(dataFetchingFinish())
                return { ...dataJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
            } else {
                const currentUnit = getState().units?.units?.filter((el: any) => el.id === Number(formValues.unitID))[0]
                const currentUser = getState().user.currentUser
                const nameUser = getNameUser(currentUser as User)
                const unitAdress = getUnitAddress(currentUnit)
                const inMomentViewingForAdmin = toUTCWithOffset(getCurrentDubaiDate(), 1)
                dispatch(dataFetchingFinish())
                dispatch(setAdvertises(dataJSON.response.data))
                dispatch(setFilterNavigate('adverts'))
                dispatch(setWhereAfterToGo("/agent/schedule"))
                await sendNotification(inMomentViewingForAdmin, Number(currentUser.id ?? userID), dataJSON.response.data.id, 'admin-advertise-links-added', `Attention admin, ${nameUser} created link an advertise for ${unitAdress}.`)
                return { ...dataJSON, textNavigate: `/agent/modalView/advertise_modal/${dataJSON?.response?.data?.attributes?.Unit?.data?.id}/${dataJSON?.response?.data?.id}/not`, isSuccessful: true, textNotification: 'You have successfully updated the advertising Trakheesi IDs' }
            }
        } else {
            dispatch(dataFetchingFinish())
            return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
        }
    } catch (error) {
        console.log(error)
        dispatch(dataFetchingFinish())
        return { textNavigate: '', isSuccessful: false, textNotification: 'Something went wrong, try again.' }
    }
}
